import { put } from 'redux-saga/effects';
import { enqueSnackAction } from '@app/store/snacks';
import { call } from 'redux-saga/effects';
import { RightsApi } from '@services/rights-service/rights-service';
import { setCOReferenceDataAction } from '..';

export function* fetchCOReferenceURSagaWorker() {
  try {
    const payload = yield call(RightsApi.getCOReferenceDataUR);

    yield put(setCOReferenceDataAction({ payload: payload.data }));
  } catch (e) {
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Failed to get Teams info.',
          options: {
            variant: 'error',
          },
          key: 'team-rights-fetch',
        },
      })
    );
  }
}
